/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type topPicturesLoadMoreQueryVariables = {|
  spaceRef: string
|};
export type topPicturesLoadMoreQueryResponse = {|
  +item: ?{|
    +pictures: ?$ReadOnlyArray<?{|
      +nameId: ?string,
      +extension: ?string,
      +predictName: ?string,
    |}>
  |}
|};
export type topPicturesLoadMoreQuery = {|
  variables: topPicturesLoadMoreQueryVariables,
  response: topPicturesLoadMoreQueryResponse,
|};
*/


/*
query topPicturesLoadMoreQuery(
  $spaceRef: String!
) {
  item: getSpaceByRef(ref: $spaceRef) {
    pictures {
      nameId
      extension
      predictName
      id
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceRef"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "ref",
    "variableName": "spaceRef"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "extension",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "predictName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "topPicturesLoadMoreQuery",
    "selections": [
      {
        "alias": "item",
        "args": (v1/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "getSpaceByRef",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SpacePicture",
            "kind": "LinkedField",
            "name": "pictures",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "topPicturesLoadMoreQuery",
    "selections": [
      {
        "alias": "item",
        "args": (v1/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "getSpaceByRef",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SpacePicture",
            "kind": "LinkedField",
            "name": "pictures",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "561b048caa7d7bc47d4ba52bcac4bade",
    "id": null,
    "metadata": {},
    "name": "topPicturesLoadMoreQuery",
    "operationKind": "query",
    "text": "query topPicturesLoadMoreQuery(\n  $spaceRef: String!\n) {\n  item: getSpaceByRef(ref: $spaceRef) {\n    pictures {\n      nameId\n      extension\n      predictName\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ad18df510048b7c69ca224cfa28ca08a';

module.exports = node;
